<script>
export default {
  inheritAttrs: false,
  model: {
    event: 'update',
  },
  props: {
    name: {
      type: String,
      default: '',
    },
    labelContent: {
      type: String,
      required: true,
    },
    fieldId: {
      type: String,
      default: '',
      required: false,
    },
    markRequired: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showPass: false,
      password: '',
    }
  },
}
</script>

<template>
  <div>
    <div>
      <label :class="$style.labelContent">{{ labelContent }}</label
      ><span v-if="markRequired" :class="$style.asteriskMark">*</span>
    </div>
    <b-input-group>
      <b-form-input
        v-show="!showPass"
        type="password"
        :class="[$style.selectbg]"
        v-bind="$attrs"
        v-on="$listeners"
        @input="$emit('update', $event)"
      />
      <b-form-input
        v-show="showPass"
        type="text"
        :class="[$style.selectbg]"
        v-bind="$attrs"
        v-on="$listeners"
        @input="$emit('update', $event)"
      />

      <b-input-group-append>
        <b-button :class="[$style.selectbg]" @click="showPass = !showPass">
          <BaseIcon v-show="!showPass" class="text-dark" name="eye" />
          <BaseIcon v-show="showPass" class="text-dark" name="eye-slash" />
        </b-button>
      </b-input-group-append>
    </b-input-group>
  </div>
</template>

<style lang="scss" module>
@import '@design';
.iconField,
.iconField:hover {
  color: dodgerblue;
  background-color: #fafafa;
  border: 1px solid #ced4da;
  border-left: 0;
}
.labelContent {
  float: left;
  margin: $size-content-label-margin 0;
  font-size: $size-content-font;
  font-weight: 500;
  color: $color-text-gray;
}
.selectbg,
.selectbg:hover,
.selectbg:active {
  background-color: $color-content-bg !important;
  border: $input-border !important;
}
.asteriskMark {
  position: relative;
  top: 10px;
  left: 2px;
  display: flex;
  color: $color-error-text;
}
</style>

<style>
.input-group-text {
  height: fit-content;
}
</style>
